
import { useField } from 'formik';
import { useSightingCategories } from '../../hooks/useSpottings';
// import { Select } from '@mantine/core';


interface CategoryDropdownProps {
    // categories: { id: string; name: string }[];
    // categoriesLoading: boolean;

    blank?: string
}

const CategoryDropdown: React.FC<CategoryDropdownProps> = () => {
    const [field, , helpers] = useField('categoryId');

    const { data: categories, isLoading: categoriesLoading } = useSightingCategories()


    if (categoriesLoading) {
        return <div>Loading...</div>
    }

    if (!categories) {
        return <div>No categories found</div>
    }

    const categoryOptions = categories.map((category) => ({
        value: category.id,
        label: category.name,
    }))

    return (
        <select
            {...field}
            onChange={(e) => helpers.setValue(e.target.value)}
            value={field.value}
            disabled={categoriesLoading}
            required
            className="w-full"
        >
            <option value="">Select a category</option>
            {categoryOptions.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default CategoryDropdown; 